<template>
  <div class="columns">
    <div class="column">
      <div class="content">
        <h2 class="title">arcdps clears</h2>
        <p>
          A plugin for arcdps which adds a window for quickly checking your current weekly clears in the game.
        </p>
        <h4>Features</h4>
        <ul>
          <li>Shows raid clears for your account(s) within the game.</li>
          <li>Shows raid clears of friends if they also use the addon.</li>
          <li>Offers multiple table styles and many other configuration options.</li>
        </ul>
        <h4>Installation</h4>
        <p>
          Check out the <a href="https://guides.gw2scratch.com/clears/">User Guide</a> for installation instructions.
        </p>
        <p>
          Note that this plugin should not need updates every time arcdps updates.
        </p>
        <h4>How to use</h4>
        <p>
          You should see a new Clears checkbox in the main arcdps menu (Shift+Alt+T by default), clicking it will open
          the Clears window (or use the default Shift+Alt+C keybind). You can then add your GW2 API keys.
        <p>
          There is a tutorial within game, or you can check out the <a href="https://guides.gw2scratch.com/clears/">User Guide</a> which will guide you through the entire process with pictures.
        </p>
        <p>
          Note that the Guild Wars 2 API has delays, often up to 5 minutes.
        </p>
        <p>
          For more details, check out the <a href="https://guides.gw2scratch.com/clears/">User Guide</a>.
        </p>
      </div>
    </div>
    <div class="column is-4">
      <ProgramDownloads release-feed-url="/releases/arcdps-clears.json" program-name="arcdps clears"/>
      <br>
      <ProgramImage :src="clearsImage" alt="Screenshot from the game"/>
    </div>
  </div>
</template>

<script>
import ProgramDownloads from "@/components/ProgramDownloads";
import ProgramImage from "@/components/ProgramImage";
import clearsImage from "@/assets/images/clears.png";

export default {
  name: 'tools-inspector',
  components: {ProgramDownloads, ProgramImage},
  data() {
    return {
      clearsImage
    }
  }
}
</script>

<style>
</style>
